export default __webpack_public_path__ + "static/media/Learn More.30570255.svg";